// extracted by mini-css-extract-plugin
export default {"Paper":"Paper_Paper__3qkv5"};